<div fxLayout="column" class="date-range" fxLayoutGap="20px">
  <mat-form-field id="dateSelect" class="width-100 font-xs" auxiliary-class [auxiliaryClassName]="customClass" appearance="outline">
    <mat-select [placeholder]="placeholder" [(ngModel)]="selectedRange">
      <mat-option *ngFor="let option of filterOptions" (click)="setDefaultDateRange(option)" [value]="option.name">
        {{ option.name }}
      </mat-option>
    </mat-select>

    <mat-icon matSuffix class="select-date-icon">
      <uni-image 
        src="https://uni-common-assets.s3.amazonaws.com/icons/system/svg/1/calendar48x48.svg" 
        [height]="24"
        [width]="24"
        alt="Date range calender"
      ></uni-image>
    </mat-icon>
  </mat-form-field>

  <mat-form-field *ngIf="selectedRange === 'Custom'" class="width-100 font-xs-static" appearance="outline">
    <mat-label>Enter a date range</mat-label>

    <mat-date-range-input [formGroup]="range" [rangePicker]="picker" required>
      <input matStartDate (change)="setDateRange(dateRangeStart.value, dateRangeEnd.value,'Custom')"
        formControlName="start" placeholder="Start date" #dateRangeStart required>

      <input matEndDate (dateChange)="setDateRange(dateRangeStart.value, dateRangeEnd.value,'Custom')"
        formControlName="end" placeholder="End date" #dateRangeEnd required>
    </mat-date-range-input>

    <mat-datepicker-toggle matSuffix [for]="picker">
      <mat-icon matDatepickerToggleIcon class="margin-0">
        <uni-image 
          src="https://uni-common-assets.s3.amazonaws.com/icons/system/svg/1/calendar48x48.svg" 
          [height]="24"
          [width]="24"
          alt="Date range calender"
        ></uni-image>
      </mat-icon>
    </mat-datepicker-toggle>

    <mat-date-range-picker #picker></mat-date-range-picker>

    <mat-error class="error-messages" *ngIf="range.controls.start.errors">Invalid start date</mat-error>
    <mat-error class="error-messages" *ngIf="range.controls.end.errors">Invalid end date</mat-error>
  </mat-form-field>
</div>
